import React from "react";
import { PanelContainer } from "./PanelContainer";
import { FlashcardsPanelContent } from "@/components/flashcards/FlashcardsPanelContent";
import { useAuth } from "@/hooks/useAuth";

interface PanelProps {
  isMobile?: boolean;
  contentId?: string | null;
  chatId?: string | null;
}

export const FlashcardsPanel: React.FC<PanelProps> = (props) => {
  const { user } = useAuth();

  const flashcardsIcon = (
    <svg
      viewBox="0 0 256 256"
      className="h-4 w-4 text-primary"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M180,72H36A20,20,0,0,0,16,92V204a20,20,0,0,0,20,20H180a20,20,0,0,0,20-20V92A20,20,0,0,0,180,72Zm-4,128H40V96H176ZM240,52V176a12,12,0,0,1-24,0V56H64a12,12,0,0,1,0-24H220A20,20,0,0,1,240,52Z"
      />
    </svg>
  );

  if (!user) {
    return (
      <PanelContainer
        {...props}
        title="Flashcards"
        description={
          <>
            Sign in to save and study flashcards. Ask Shattara AI:{" "}
            <span className="font-bold">"Create 10 flashcards about photosynthesis."</span>
          </>
        }
        icon={flashcardsIcon}
      >
        <div className="p-3 text-xs text-muted-foreground">
          Please log in to use flashcards.
        </div>
      </PanelContainer>
    );
  }

  return (
    <PanelContainer
      {...props}
      title="Flashcards"
      description={
        <>
          Try asking Shattara AI:{" "}
          <span className="font-bold">
            "Create 10 flashcards about photosynthesis."
          </span>
        </>
      }
      icon={flashcardsIcon}
    >
      <FlashcardsPanelContent
        userId={user.id}
        contentId={props.contentId ?? null}
        chatId={props.chatId ?? null}
      />
    </PanelContainer>
  );
};
